export default "__VITE_ASSET__CYyz$emZ__"